import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from '../shared/Sidebar';
import Header from '../shared/Header';

// TODO: refactor this template compnent impl by styled-components
const WithHeaderSidebar = ({ children, user }) => (
  <div>
    <Header user={user} />
    <div className="container-fluid">
      <div className="row">
        <Sidebar user={user} />
        <div className="pb-content">
          {children}
        </div>
      </div>
    </div>
  </div>
);

WithHeaderSidebar.propTypes = {
  children: PropTypes.node.isRequired,
  user: PropTypes.shape(),
};

WithHeaderSidebar.defaultProps = {
  user: {},
};

export default WithHeaderSidebar;
